var _defs, _metadata, _rect, _path, _g, _path2, _g2, _circle, _g3, _circle2, _circle3, _circle4, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 1911 1546",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:43.6356}\r\n    .str1 {stroke:black;stroke-width:43.6356;stroke-linecap:round}\r\n    .fil0 {fill:none}\r\n    .fil5 {fill:black}\r\n    .fil2 {fill:#B18278}\r\n    .fil1 {fill:#FFD6AA}\r\n    .fil4 {fill:white}\r\n    .fil3 {fill:white;fill-rule:nonzero}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M956 289c-62,-1 -417,12 -621,451 -247,532 215,598 621,598 405,0 867,-65 620,-598 -204,-439 -559,-452 -620,-451z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_650655848"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 1911,
    height: 1546
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M956 289c-62,-1 -417,12 -621,451 -247,532 215,598 621,598 405,0 867,-65 620,-598 -204,-439 -559,-452 -620,-451z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil2",
    d: "M683 670c112,0 203,99 203,220 0,56 -19,107 -51,145 38,-6 78,-9 121,-9 42,0 83,3 120,9 -31,-38 -50,-89 -50,-145 0,-121 90,-220 202,-220 112,0 202,99 202,220 0,114 -78,207 -179,219 15,16 23,33 23,51 0,74 -142,134 -318,134 -176,0 -319,-60 -319,-134 0,-18 8,-35 23,-51 -101,-12 -179,-105 -179,-219 0,-121 91,-220 202,-220z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M956 289c-62,-1 -417,12 -621,451 -247,532 215,598 621,598 405,0 867,-65 620,-598 -204,-439 -559,-452 -620,-451z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M842 898l-87 0 0 0 0 -4 -1 -4 0 -4 -1 -4 0 -3 -1 -4 -1 -3 -2 -4 -1 -3 -1 -3 -2 -3 -2 -3 -2 -3 -2 -3 -2 -3 -2 -2 -2 -3 -2 -2 -3 -2 -2 -2 -3 -2 -3 -1 -2 -2 -3 -1 -3 -1 -2 -1 -3 -1 -3 -1 -3 0 -3 -1 -3 0 -3 0 0 -87 8 0 8 0 7 1 8 2 7 2 8 2 7 3 7 3 6 3 7 4 6 4 6 4 6 5 6 4 5 6 5 5 5 6 5 5 4 6 4 7 4 6 3 7 4 7 3 7 2 7 2 7 2 8 2 7 1 8 1 8 1 8 0 8 0 0zm-150 160l0 -87 0 0 3 0 3 0 3 -1 3 0 3 -1 3 -1 2 -1 3 -1 3 -1 2 -2 3 -2 3 -1 2 -2 3 -2 2 -3 2 -2 2 -3 2 -2 2 -3 2 -3 2 -3 2 -3 1 -3 1 -3 2 -4 1 -3 1 -4 0 -4 1 -3 0 -4 1 -4 0 -4 87 0 0 8 -1 8 -1 8 -1 7 -2 8 -2 8 -2 7 -2 7 -3 7 -4 7 -3 7 -4 6 -4 6 -4 6 -5 6 -5 6 -5 5 -5 5 -6 5 -6 5 -6 4 -6 4 -7 4 -6 3 -7 3 -7 3 -8 2 -7 2 -8 1 -7 1 -8 1 -8 0 0 0zm-150 -160l87 0 0 0 0 4 1 4 0 4 1 3 0 4 1 4 1 3 2 4 1 3 1 3 2 3 2 3 2 3 2 3 2 2 2 3 2 2 2 3 3 2 2 2 3 1 3 2 2 2 3 1 3 1 2 1 3 1 3 1 3 0 3 1 3 0 3 0 0 87 -8 0 -8 -1 -7 -1 -8 -1 -7 -2 -8 -2 -7 -3 -7 -3 -6 -3 -7 -4 -6 -4 -6 -4 -6 -5 -6 -5 -5 -5 -5 -5 -5 -6 -5 -6 -4 -6 -4 -6 -4 -6 -3 -7 -4 -7 -3 -7 -2 -7 -2 -7 -2 -8 -2 -8 -1 -7 -1 -8 -1 -8 0 -8 0 0zm150 -160l0 87 0 0 -3 0 -3 0 -3 1 -3 0 -3 1 -3 1 -2 1 -3 1 -3 1 -2 2 -3 1 -3 2 -2 2 -3 2 -2 2 -2 3 -2 2 -2 3 -2 3 -2 3 -2 3 -2 3 -1 3 -1 3 -2 4 -1 3 -1 4 0 3 -1 4 0 4 -1 4 0 4 -87 0 0 -8 1 -8 1 -8 1 -8 2 -7 2 -8 2 -7 2 -7 3 -7 4 -7 3 -7 4 -6 4 -7 4 -6 5 -5 5 -6 5 -5 5 -6 6 -4 6 -5 6 -4 6 -4 7 -4 6 -3 7 -3 7 -3 8 -2 7 -2 8 -2 7 -1 8 0 8 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M692 781c59,0 106,52 106,117 0,64 -47,117 -106,117 -59,0 -106,-53 -106,-117 0,-65 47,-117 106,-117z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 721,
    cy: 899,
    r: 97
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1069 898l0 0 1 -8 0 -8 1 -8 1 -8 2 -7 2 -8 2 -7 3 -7 3 -7 3 -7 3 -7 4 -6 4 -7 4 -6 5 -5 5 -6 5 -5 5 -6 6 -4 6 -5 6 -4 6 -4 7 -4 7 -3 6 -3 8 -3 7 -2 7 -2 8 -2 8 -1 7 0 8 0 0 87 -3 0 -3 0 -3 1 -3 0 -3 1 -2 1 -3 1 -3 1 -3 1 -2 2 -3 1 -2 2 -3 2 -2 2 -3 2 -2 3 -2 2 -2 3 -2 3 -2 3 -2 3 -1 3 -2 3 -1 3 -1 4 -2 3 0 4 -1 3 -1 4 0 4 -1 4 0 4 0 0 -87 0zm150 160l0 0 -8 0 -7 -1 -8 -1 -8 -1 -7 -2 -7 -2 -8 -3 -6 -3 -7 -3 -7 -4 -6 -4 -6 -4 -6 -5 -6 -5 -5 -5 -5 -5 -5 -6 -5 -6 -4 -6 -4 -6 -4 -6 -3 -7 -3 -7 -3 -7 -3 -7 -2 -7 -2 -8 -2 -8 -1 -7 -1 -8 0 -8 -1 -8 87 0 0 4 1 4 0 4 1 3 1 4 0 4 2 3 1 4 1 3 2 3 1 3 2 3 2 3 2 3 2 2 2 3 2 2 3 3 2 2 3 2 2 1 3 2 2 2 3 1 3 1 3 1 2 1 3 1 3 0 3 1 3 0 3 0 0 0 0 87zm150 -160l0 0 0 8 -1 8 -1 8 -1 7 -1 8 -2 8 -3 7 -2 7 -3 7 -3 7 -4 7 -4 6 -4 6 -4 6 -5 6 -5 6 -5 5 -5 5 -6 5 -6 5 -6 4 -6 4 -6 4 -7 3 -7 3 -7 3 -7 2 -8 2 -7 1 -8 1 -8 1 -8 0 0 -87 3 0 3 0 3 -1 3 0 3 -1 3 -1 3 -1 2 -1 3 -1 3 -2 2 -2 3 -1 2 -2 3 -2 2 -3 2 -2 2 -3 3 -2 2 -3 1 -3 2 -3 2 -3 1 -3 2 -3 1 -4 1 -3 1 -4 1 -4 0 -3 1 -4 0 -4 0 -4 0 0 87 0zm-150 -160l0 0 8 0 8 0 8 1 7 2 8 2 7 2 7 3 7 3 7 3 6 4 6 4 6 4 6 5 6 4 5 6 5 5 5 6 5 5 4 6 4 7 4 6 4 7 3 7 3 7 2 7 3 7 2 8 1 7 1 8 1 8 1 8 0 8 -87 0 0 -4 0 -4 -1 -4 0 -4 -1 -3 -1 -4 -1 -3 -1 -4 -2 -3 -1 -3 -2 -3 -2 -3 -1 -3 -2 -3 -3 -3 -2 -2 -2 -3 -2 -2 -3 -2 -2 -2 -3 -2 -2 -1 -3 -2 -3 -1 -2 -1 -3 -1 -3 -1 -3 -1 -3 0 -3 -1 -3 0 -3 0 0 0 0 -87z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M1219 781c-59,0 -106,52 -106,117 0,64 47,117 106,117 59,0 107,-53 107,-117 0,-65 -48,-117 -107,-117z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fil5",
    cx: 1190,
    cy: 899,
    r: 97
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 1161,
    cy: 899,
    r: 38
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 750,
    cy: 899,
    r: 38
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M1565 407c42,25 288,66 154,235 -133,169 -204,146 -238,151 -33,6 -204,-45 -233,-225 -30,-181 16,-285 114,-279 98,6 160,94 203,118z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil2 str0",
    d: "M347 407c-43,25 -288,66 -155,235 134,169 204,146 238,151 33,6 204,-45 233,-225 30,-181 -15,-285 -113,-279 -99,6 -161,94 -203,118z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M955 1112c0,31 2,63 0,94 -3,47 -105,54 -111,-30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M956 1112c0,31 -2,63 0,94 3,47 105,54 111,-30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M956 1175c43,0 115,-70 93,-92 -21,-21 -165,-21 -187,0 -22,22 50,92 94,92z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni1);
export default __webpack_public_path__ + "static/media/ani1.62dc3630a5856abe7d462326dbc04520.svg";
export { ForwardRef as ReactComponent };